import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  AndroidIcon,
  IphoneIcon,
  GameIcon,
  FlutterIcon,
  HealthcareIcon,
  ReactIcon,
} from "../../../app-constants";
import { Link } from "gatsby";

const StackItem = [
  {
    icon: AndroidIcon,
    title: "Android app development",
    description: (
      <>
        Consider us a reliable{" "}
        <Link
          to="/android-app-development"
          rel="noopener"
          aria-label="TekRevol"
        >
          Android app development company
        </Link>{" "}
        in Indianapolis that excels in creating native Android apps. We utilize
        the capabilities of the world's most widely used mobile platform
        supported by our efficiency strategy. Through a dynamic tech stack of
        Java or Kotlin and relevant frameworks, we bring your app ideas to life
        with innovation.
      </>
    ),
  },
  {
    icon: IphoneIcon,
    title: "Iphone app development",
    description: (
      <>
        Experience premium functionality of mobile apps with our{" "}
        <Link to="/iphone-app-development" rel="noopener" aria-label="TekRevol">
          iOS App Development services
        </Link>{" "}
        Our skilled developers are dedicated to creating apps that ensure a
        pleasing UI and efficient functionality that iOS users expect. We pay
        the required attention to every detail, ensuring your app aligns
        perfectly with Apple's design principles and guidelines.
      </>
    ),
  },
  {
    icon: GameIcon,
    title: "Game app development",
    description:
      "We can bring your game idea to life with our efficient game app development in Indianapolis. Our expert developers create stunning games with high-quality graphics, strong storylines, and deep programming along with a smooth experience for players. So, you can develop any game with us from basic to complex on a large scale.",
  },
  {
    icon: FlutterIcon,
    title: "Flutter app development",
    description:
      "We can build feature-rich applications using Flutter as a full-fledged cross-platform app development framework. TekRevol has the expertise to deliver efficient digital solutions for Android and iOS using Flutter. This will be an amazing opportunity for you to scale your business on a new level as we have already worked on 100+ Flutter projects.",
  },
  {
    icon: HealthcareIcon,
    title: "Healthcare app development",
    description: (
      <>
        We{" "}
        <Link
          to="/healthcare-app-development"
          rel="noopener"
          aria-label="TekRevol"
        >
          healthcare app development services
        </Link>{" "}
        based on our expertise in this industry to build innovative solutions.
        You can streamline your healthcare operations with efficient systems to
        handle the complex processes, we are here to facilitate you. We create
        apps that assist our clients to stand, elevating the overall standard of
        medical assistance towards patients.
      </>
    ),
  },
  {
    icon: ReactIcon,
    title: "React Native app development",
    description:
      "We leverage the power of React Native to construct comprehensive mobile applications for both Android and iOS platforms. That’s how we ensure extensive functionality and deliver premium performance through our app solutions. Our skilled team actively builds apps that meet your specific requirements but also provide a consistently high-quality user experience.",
  },
];

function Improvise(props) {
  return (
    <div className="improvise_section p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={4}
            className="m-xl-auto m-xxl-0"
          >
            <h2>
              Innovate Your Business Process with Our Indianapolis Mobile App
              Development Services
            </h2>
            <p className="impro_para">
              We're more than just a mobile app development company in
              Indianapolis – we're your partner in business innovation.
              Considering the impact of mobile apps, businesses are presented
              with a compelling opportunity to leverage this technology to
              increase their reach by engaging with a vast user base. Following
              are the services that we offer for app development in Indianapolis
              to help your business thrive in the competitive digital market.
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={8}>
            <div className="stack_box">
              {StackItem.map((item, index) => (
                <div className="stack_item" key={index}>
                  <div className="stack_title">
                    {item.icon}
                    <h5>{item.title}</h5>
                  </div>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Improvise;
